import { Directive, Input, TemplateRef } from '@angular/core';

@Directive({
  selector: '[filterTemplate]',
})
export class FilterTemplateDirective {
  @Input()
  field!: string;
  constructor(public template: TemplateRef<any>) {}
}
